// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"6341bc6d","434":"5ff28f59","907":"f2eb9233","938":"55dac99f","971":"d89a2165"}[chunkId] + ".chunk.js";
};